import React from "react";
import ImageUploadField from "./ImageUploadField";
import { THEME_PRESETS } from "../utils/businessThemes";

export default function PoliticalGalleryTab({ form, set, gallery, setGallery, personaluid }) {
    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Photo Gallery</span>
                    <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setGallery([...gallery, ""])}
                    >
                        <i className="bi bi-plus-lg me-1" />
                        Add Photo
                    </button>
                </div>
                <div className="card-body">
                    {gallery.length === 0 ? (
                        <p className="text-muted mb-0">No photos in gallery yet.</p>
                    ) : (
                        <div className="row g-3">
                            {gallery.map((g, i) => (
                                <div className="col-md-4" key={i}>
                                    <ImageUploadField
                                        value={g}
                                        onChange={(v) => {
                                            const c = [...gallery];
                                            c[i] = v;
                                            setGallery(c);
                                        }}
                                        purpose="gallery"
                                        personaluid={personaluid}
                                        placeholder="Upload photo"
                                    />
                                    <button
                                        className="btn btn-sm btn-outline-danger mt-2 w-100"
                                        onClick={() => removeAt(gallery, setGallery, i)}
                                    >
                                        <i className="bi bi-trash me-1" />
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Social Links & Video</div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label small">Facebook URL</label>
                            <input
                                className="form-control form-control-sm"
                                placeholder="https://facebook.com/..."
                                value={form.linkfacebook}
                                onChange={(e) => set("linkfacebook", e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Instagram URL</label>
                            <input
                                className="form-control form-control-sm"
                                placeholder="https://instagram.com/..."
                                value={form.linkinstagram}
                                onChange={(e) => set("linkinstagram", e.target.value)}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label small">Twitter / X URL</label>
                            <input
                                className="form-control form-control-sm"
                                placeholder="https://twitter.com/..."
                                value={form.linktwitter}
                                onChange={(e) => set("linktwitter", e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">LinkedIn URL</label>
                            <input
                                className="form-control form-control-sm"
                                placeholder="https://linkedin.com/..."
                                value={form.linklinkedin || ""}
                                onChange={(e) => set("linklinkedin", e.target.value)}
                            />
                        </div>

                        <div className="col-12">
                            <label className="form-label small">YouTube Video Link</label>
                            <input
                                className="form-control form-control-sm"
                                placeholder="https://www.youtube.com/watch?v=..."
                                value={form.youtube_link}
                                onChange={(e) => set("youtube_link", e.target.value)}
                            />
                            <small className="form-text text-muted mt-1">
                                Link to a YouTube video (speech, interview, campaign video, etc.)
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Website Theme Colour</div>
                <div className="card-body">
                    <p className="text-muted small mb-2">Choose a colour theme for your political website:</p>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        {THEME_PRESETS.map((t) => (
                            <button
                                key={t.key}
                                type="button"
                                title={t.label}
                                onClick={() => set("theme_color", t.key)}
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: 8,
                                    border: "none",
                                    background: `linear-gradient(135deg, ${t.brand}, ${t.brand2})`,
                                    outline: (form.theme_color || "classic-navy") === t.key ? `3px solid ${t.accent}` : "2px solid transparent",
                                    outlineOffset: 2,
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    transition: "all 0.2s",
                                }}
                            >
                                {(form.theme_color || "classic-navy") === t.key && <i className="bi bi-check-lg" />}
                            </button>
                        ))}
                    </div>
                    <div className="form-text">
                        <b>Selected:</b> {THEME_PRESETS.find((t) => t.key === form.theme_color)?.label || "Classic Navy"} —{" "}
                        this changes the colours on your live political website.
                    </div>
                </div>
            </div>
        </div>
    );
}